import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";
import { AdminProductsActions } from "../../actions/admin-products.actions";
import { ProductsState } from "../../models/mp-admin/products-state";

const initialState: ProductsState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(AdminProductsActions.products.getApi, (state) => ({
		...state,
		loading: true
	})),
	on(AdminProductsActions.products.getSuccess, (state, action) => ({
		..._.omit(state, "error"),
		...action.state,
		loading: false
	})),
	on(AdminProductsActions.products.getFail, (state, action) => ({
		...state,
		error: action.error,
		loading: action.loading
	})),
	on(AdminProductsActions.products.invalidate, () => initialState)
);

export function productsReducer(
	state: ProductsState | undefined,
	action: Action
): ProductsState {
	return reducer(state, action);
}
